// TODO check all events and add more if there are any

/**
 * Add functions for Snapchat Ads
 * */

(function (wpm, $, undefined) {

	wpm.snapchatGetEmail = function () {
		let userInfo = {}

		if (wpmDataLayer?.user?.email_sha256) {
			userInfo.user_hashed_email = wpmDataLayer.user?.email_sha256
		}
		// console.log(userInfo)
		return userInfo
	}

	wpm.loadSnapchatPixel = function () {

		try {
			if (wpmDataLayer?.pixels?.snapchat?.pixel_id) {

				wpmDataLayer.pixels.snapchat.loaded = true;

				// @formatter:off
    			(function(e,t,n){if(e.snaptr)return;var a=e.snaptr=function()
    			{a.handleRequest?a.handleRequest.apply(a,arguments):a.queue.push(arguments)};
    				a.queue=[];var s='script';r=t.createElement(s);r.async=!0;
    				r.src=n;var u=t.getElementsByTagName(s)[0];
    				u.parentNode.insertBefore(r,u);})(window,document,
    				'https://sc-static.net/scevent.min.js');
    			// @formatter:on

				snaptr("init", wpmDataLayer.pixels.snapchat.pixel_id, wpm.snapchatGetEmail())
				snaptr("track", "PAGE_VIEW")
			}
		} catch (e) {
			console.error(e)
		}
	}

	wpm.getSnapchatOrderItemIds = function () {
		let contentIds = []

		for (const [key, item] of Object.entries(wpmDataLayer.order.items)) {

			if (wpmDataLayer?.general?.variationsOutput && 0 !== item.variation_id) {
				contentIds.push(String(wpmDataLayer.products[item.variation_id].dyn_r_ids[wpmDataLayer.pixels.snapchat.dynamic_remarketing.id_type]))
			} else {
				contentIds.push(String(wpmDataLayer.products[item.id].dyn_r_ids[wpmDataLayer.pixels.snapchat.dynamic_remarketing.id_type]))
			}
		}

		return contentIds
	}

}(window.wpm = window.wpm || {}, jQuery));

/**
 * Execute as soon as possible
 * */

(function () {

	jQuery(document).on("wpmLoadPixels", function () {

		if (wpm.canIFire("ads", "snapchat-ads") && !wpmDataLayer?.pixels?.snapchat?.loaded) wpm.loadSnapchatPixel()

	})

})()


/**
 * All event listeners
 * */

// AddToCart event
jQuery(document).on("wpmAddToCart", function (event, product) {

	try {
		if (!wpmDataLayer?.pixels?.snapchat?.loaded) return

		snaptr("track", "ADD_CART", {
			item_ids: [product.dyn_r_ids[wpmDataLayer.pixels.snapchat.dynamic_remarketing.id_type]],
		})
	} catch (e) {
		console.error(e)
	}
})

// VIEW_CONTENT event
jQuery(document).on("wpmViewItem", function (event, product) {

	try {
		if (!wpmDataLayer?.pixels?.snapchat?.loaded) return

		snaptr("track", "VIEW_CONTENT", {
			item_ids: [product.dyn_r_ids[wpmDataLayer.pixels.snapchat.dynamic_remarketing.id_type]],
		})
	} catch (e) {
		console.error(e)
	}
})


// view order received page event
jQuery(document).on("wpmOrderReceivedPage", function () {

	try {
		if (!wpmDataLayer?.pixels?.snapchat?.loaded) return

		snaptr("track", "PURCHASE", {
			currency      : wpmDataLayer.order.currency,
			price         : wpmDataLayer.order.value_filtered,
			transaction_id: wpmDataLayer.order.id,
			item_ids      : wpm.getSnapchatOrderItemIds(),
		})

		// console.log(wpm.getSnapchatOrderItemIds())
		// console.log({price: wpmDataLayer.order.value_filtered})
		// console.log({transaction_id: wpmDataLayer.order.id})
	} catch (e) {
		console.error(e)
	}
})
